'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import { MainLayout } from './MainLayout';

type Props = { children: React.ReactNode; initialServerAuth?: boolean };

export function LayoutSelector({ children, initialServerAuth }: Props) {
  const pathname = usePathname();

  // If we're on the login route, render children directly (minimal layout).
  if (pathname && pathname.startsWith('/login')) {
    return <>{children}</>;
  }

  return <MainLayout initialServerAuth={initialServerAuth}>{children}</MainLayout>;
}

export default LayoutSelector;
